
export const getAuthUser = (state) => state.authState.currentUser;

export const isAuthenticated = (state) => state.authState.currentUser != null;
